import Link from 'next/link';

export default function Title (props) {
  const title = props.title || props.text || 'TITLE';
  const desc = props.desc || '';

  return (
    <div className='module_titleline_w'>
      <h3
        className='module_titleline_title'
        tabIndex={props.view || props.view === undefined ? '0' : '-1'}
        aria-label={title}
      >{title}
      </h3>
      {props.link && props.link.charAt(0) === '/' && (
        <Link href={`${(props.link.indexOf('/m') > -1 ? props.link : `/m${props.link}`)}`}>
          <a className='module_titleline_link'>
            {desc}
          </a>
        </Link>)}
      {props.link && props.link.charAt(0) !== '/' && (
        <a href={`${props.link}`} className='module_titleline_link'>
          {desc}
        </a>)}

      {/* 이벤트 일시 전체 이동하기 버튼 추가 */}
      {props.mainContentsType === 'event' && (<a href='/event' className='module_titleline_link'>전체보기</a>)}

      {/* 프리미엄뉴스 일시 전체 이동하기 버튼 추가 */}
      {props.type === 'pnews' && (<a href='https://premium.sbs.co.kr/?utm_source=sbsmain' target='_blank' className='module_titleline_link'>전체보기</a>)}
    </div>
  );
}
